import { useSelector } from 'react-redux';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { getEndpointRetries } from '../store/http-responses/selectors';
import { getSignupGtkmDataEntries } from '../store/signup-data/selectors';
import { Data } from 'signup-constants/signupData/Data';
import { getDataKeysByStep } from '../step/getStepData';
import { getGTKMEndpointKey } from '../utils/gtkm/getGTKMEndpointKey';
import { isAssignedToGTKMExperiment } from '../utils/gtkm/isAssignedToGTKM';
export const useGTKMSingleFieldReturned = () => {
  var _gtkmData$find;
  const {
    currentStep
  } = useCurrentStep();
  const dataKeys = getDataKeysByStep([currentStep]);
  const isAssignedToGTKM = useSelector(state => isAssignedToGTKMExperiment(state));
  const endpointKey = useSelector(state => getGTKMEndpointKey(state));
  const gtkmEndpointRetries = useSelector(state => getEndpointRetries(state, endpointKey));
  const gtkmData = useSelector(state => getSignupGtkmDataEntries(state));
  let gtkmOneFieldReturned = false;
  const gtkmNonDomainKey = gtkmData.length === 2 ? ((_gtkmData$find = gtkmData.find(([key]) => key !== Data.CompanyDomain)) === null || _gtkmData$find === void 0 ? void 0 : _gtkmData$find[0]) || null : null;
  if (isAssignedToGTKM && gtkmNonDomainKey && dataKeys.includes(gtkmNonDomainKey) && gtkmEndpointRetries === 1) {
    gtkmOneFieldReturned = true;
  }
  return {
    gtkmOneFieldReturned,
    gtkmNonDomainKey
  };
};